import { IAcquisition } from '@models/acquisition';

export const getAcquisitionNames = (acquisitions: IAcquisition[], acquisitionIds: number[] | string): string => {
  acquisitionIds = `${acquisitionIds}`.split(',').map(Number);

  return (
    acquisitions &&
    acquisitionIds.length > 0 &&
    acquisitionIds
      .map(n => {
        const acq = acquisitions.find(({ AcquisitionId }) => AcquisitionId === n);
        return acq && acq.AcquisitionName ? acq.AcquisitionName : null;
      })
      .filter(Boolean)
      .join(', ')
  );
};
